"use strict";
// @ts-ignore
if (window && window.mosaic && window.mosaic.webpackPublicPath) {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    __webpack_public_path__ = window.mosaic.webpackPublicPath + '/';
}
